import { useEffect, useState } from 'react';
import { APONTAMENTO } from './index';

/**
 * @typedef Requisicao
 * @property {number} status
 * @property {string} dataPrevistaFatura
 * @property {boolean} [canDelete]
 */

/**
 * Hook que valida componentes do Apontamento
 * @param {Requisicao} requisicao
 * @param {AcessoUsuario} acesso
 * @param {boolean} existemColaboradoresExcedentes
 * @returns {[{
 *   habilitarReabertura: boolean,
 * }]}
 */
export default (requisicao, acesso, isRequisicaoReabertura) => {
  const verificaStatus = () => {
    // @TODO: Mover estas validações para o backend
    let habilitarReabertura = false;
    let habilitarCancelar = true;
    let habilitarFiltros = true;
    let habilitarExcluir = false;
    // eslint-disable-next-line prefer-const
    let habilitarSolicitacaoAssinaturaContrato = false;

    // Verifica se o apontamento não foi enviada
    if (requisicao.status === APONTAMENTO.status.rascunho && requisicao.dataPrevistaFatura === null) {
      habilitarReabertura = false;
    }

    // Verifica se o apontamento foi enviada para o gestor
    if (
      [APONTAMENTO.status.enviada, APONTAMENTO.status.transmitida, APONTAMENTO.status.reabertura_cancelada].includes(
        requisicao.status
      )
    ) {
      habilitarReabertura = true;
    }

    // Verifica se o adminstrador pode reabrir a solicitação feita pelo gestor
    if (
      [APONTAMENTO.status.reabertura_pendente, APONTAMENTO.status.processada, APONTAMENTO.status.faturada].includes(
        requisicao.status
      ) &&
      acesso.isAdmin()
    ) {
      habilitarReabertura = true;
    }

    // Verifica se o gestor solicitou reabertura
    if (acesso.isGestor() && requisicao.status === APONTAMENTO.status.reabertura_pendente) {
      habilitarReabertura = false;
    }

    // Verifica se a requisição foi cancelada
    // https://4beebwg.atlassian.net/browse/FP2-3943
    if ([APONTAMENTO.status.cancelado, APONTAMENTO.status.rascunho].includes(requisicao.status) || acesso.isGestor()) {
      habilitarCancelar = false;
    }

    if (isRequisicaoReabertura && requisicao.status === APONTAMENTO.status.reabertura_pendente) {
      habilitarFiltros = false;
    }

    // https://4beebwg.atlassian.net/browse/FP2-3943
    if (requisicao.canDelete) {
      habilitarExcluir = true;
    }

    if (
      requisicao.status === APONTAMENTO.status.rascunho &&
      requisicao?.colaboradores?.some((c) => !c.hasSignedContract)
    ) {
      habilitarSolicitacaoAssinaturaContrato = true;
    }

    return {
      habilitarReabertura,
      habilitarCancelar,
      habilitarExcluir,
      habilitarFiltros,
      habilitarSolicitacaoAssinaturaContrato,
    };
  };

  const [validacao, setValidacao] = useState(verificaStatus());

  useEffect(() => {
    setValidacao({ ...validacao, ...verificaStatus() });
  }, [(requisicao || {}).status, (requisicao || {}).dataPrevistaFatura, (requisicao || {}).id, (requisicao || {}).canDelete]);

  return [validacao, setValidacao];
};
